import _regeneratorRuntime from "/data/repos/372_20260903142405/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/repos/372_20260903142405/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import ShareWechat from './components/app/ShareWechat.vue';
import { REPORT2025_DETAIL_UPDATE } from '@/store/mutationTypes';
import { emitBlur, emitFocus } from './composables/events';
export default {
  components: {
    ShareWechat: ShareWechat
  },
  data: function data() {
    return {
      isFocus: false
    };
  },
  computed: {
    path: function path() {
      return this.$route.path;
    },
    keepAlive: function keepAlive() {
      return (this.$route.meta || {}).keepAlive;
    },
    stateAudio: function stateAudio() {
      var audio = this.$store.state.audio;
      return audio;
    }
  },
  methods: {
    fnResize: function fnResize() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var deviceWidth, deviceHeight, isFoldableScreen, currentWidthHeightRatio, baseWidthHeightRatio, contentRatio, contentMaskColor, viewportRatio, viewportLeft, contentShareRatio;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isFocus) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              deviceWidth = _this.isInDingTalk ? _this.$refs.wrap.clientWidth : document.documentElement.clientWidth || window.innerWidth;
              deviceHeight = _this.isInDingTalk ? _this.$refs.wrap.clientHeight : document.documentElement.clientHeight || window.innerHeight;
              console.log('wrapclientHeight', _this.$refs.wrap.clientHeight);
              console.log('window.screen.height', window.screen.height);
              console.log('document.documentElement.clientHeight', document.documentElement.clientHeight);
              isFoldableScreen = parseInt(deviceHeight / deviceWidth * 1000) / 1000 < 1.4; // 是否折叠屏
              // 折叠屏vw计算比例
              // 内容比例
              // const viewportWidth = process?.env?.VUE_APP_VIEWPORT_WIDTH || 375;
              currentWidthHeightRatio = deviceWidth / deviceHeight;
              baseWidthHeightRatio = 375 / 812;
              contentRatio = currentWidthHeightRatio >= baseWidthHeightRatio ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
              contentMaskColor = contentRatio === 1 ? 'transparent' : "rgba(0,0,0,0.5)"; // 视图比例
              viewportRatio = isFoldableScreen ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
              viewportLeft = isFoldableScreen ? '0' : '0';
              contentShareRatio = isFoldableScreen ? baseWidthHeightRatio / currentWidthHeightRatio : 1;
              console.log('--content-ratio', contentRatio);
              console.log(deviceWidth);
              console.log('--viewport-ratio', viewportRatio);
              document.documentElement.style.setProperty('font-size', "".concat(deviceWidth / 30, "px"));
              document.documentElement.style.setProperty('--content-ratio', contentRatio);
              document.documentElement.style.setProperty('--content-mask-color', contentMaskColor);
              document.documentElement.style.setProperty('--viewport-ratio', viewportRatio);
              document.documentElement.style.setProperty('--viewport-left', viewportLeft);
              document.documentElement.style.setProperty('--viewport-right', viewportLeft);
              document.documentElement.style.setProperty('--content-share-ratio', contentShareRatio);
              if (contentRatio < 0.5) {
                contentRatio = 0.5;
              }
              _this.$store.commit('yearReport2025/' + REPORT2025_DETAIL_UPDATE, {
                contentRatio: contentRatio,
                isLowerDevice: true,
                deviceHeight: deviceHeight
              });
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  beforeCreate: function beforeCreate() {
    // zeeho APP或小程序内webview无token时
    if ((this.isMiniapp || this.isApp) && !/token=[\w_-]+/.test(window.location.hash)) {
      localStorage.removeItem('token');
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    window.addEventListener('resize', this.fnResize);
    this.fnResize();
    // app兼容
    document.body.parentNode.className = document.body.parentNode.className + (this.isApp || this.isInDingTalk ? 'is-app' : '');
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', function () {});

    // 解决非虚拟键盘输入时，页面适配比例不变
    document.addEventListener('focus', function (e) {
      _this2.isFocus = true;
      emitFocus(e);
    }, true);
    document.addEventListener('blur', function (e) {
      _this2.isFocus = false;
      emitBlur(e);
    }, true);

    // 解决ios输入表单被键盘顶上后无法恢复的问题
    if (this.isApple) {
      var oldScrollTop = 0;
      var isFocus = false; // 防止输入框之前切换时界面上下滚动
      var handleFocus = function handleFocus(e) {
        isFocus = true;
        // e.target.scrollIntoView({ behavior: 'smooth' });
        setTimeout(function () {
          // console.log('focus');
          oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          isFocus = false;
          // ios 16系统键盘顶不上去
          function isiOS16() {
            var ua = navigator.userAgent;
            var iosVersionStr = /OS (\d+)_(\d+)_?(\d+)?/.exec(ua);
            var version = iosVersionStr ? parseInt(iosVersionStr[1], 10) : null;
            return version === 16;
          }
          if (['INPUT', 'TEXTAREA'].some(function (val) {
            return val === e.target.tagName;
          }) && oldScrollTop === 0 && isiOS16()) {
            document.documentElement.scrollTop = document.body.scrollHeight;
          }
        }, 100);
      };
      var handleBlur = function handleBlur() {
        console.log(oldScrollTop, document.documentElement.scrollTop || document.body.scrollTop);
        setTimeout(function () {
          if (isFocus) return;
          if (window.scrollTo) {
            // console.log('blur');
            window.scrollTo(0, oldScrollTop);
          }
        }, 50);
      };
      document.addEventListener('focus', handleFocus, true);
      document.addEventListener('blur', handleBlur, true);
    }
  },
  watch: {
    $route: {
      deep: true,
      handler: function handler(newValue) {
        // 滚动条自动滚动5px，然后回位(避免ios回退偶现白屏)
        var meta = newValue.meta || {};
        console.log(meta);
        this.$nextTick(function () {
          if (window.scrollTo) {
            var scrollTop = document.documentElement.scrollTop + 5;
            window.scrollTo(0, document.documentElement.scrollHeight);
            window.scrollTo(0, scrollTop);
          }
        });
        if (!meta.visibleAudio) {
          this.$audio.pause();
        }
      }
    }
  }
};